import React from 'react';
import { Sparkles, Loader2, AlertCircle } from 'lucide-react';
import { PhotoAiLens } from '../types';

interface AiLensBadgeProps {
  aiLens?: PhotoAiLens;
  size?: 'sm' | 'md';
}

/**
 * Small badge shown on photo thumbnails indicating AI Lens status.
 * - Spinner (analyzing)
 * - Sparkle (completed, has data)
 * - Alert (failed)
 * - Nothing (pending/no data)
 */
const AiLensBadge: React.FC<AiLensBadgeProps> = ({ aiLens, size = 'sm' }) => {
  if (!aiLens) return null;

  const iconSize = size === 'sm' ? 12 : 16;
  const badgeSize = size === 'sm' ? 'w-5 h-5' : 'w-6 h-6';

  switch (aiLens.status) {
    case 'analyzing':
      return (
        <div className={`absolute bottom-1.5 left-1.5 ${badgeSize} bg-amber-500/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-sm`}>
          <Loader2 size={iconSize} className="text-white animate-spin" />
        </div>
      );

    case 'completed':
      return (
        <div className={`absolute bottom-1.5 left-1.5 ${badgeSize} bg-violet-500/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-sm`}>
          <Sparkles size={iconSize} className="text-white" />
        </div>
      );

    case 'failed':
      return (
        <div className={`absolute bottom-1.5 left-1.5 ${badgeSize} bg-red-500/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-sm`}>
          <AlertCircle size={iconSize} className="text-white" />
        </div>
      );

    case 'pending':
    default:
      return null;
  }
};

export default AiLensBadge;
